import React, { useEffect, useState } from "react";
import Checkbox from "react-custom-checkbox";
import { Box, MenuItem, Select, Tooltip } from "@mui/material";
import "./PDFSign.css";
import PDFSignature from "./PDFSignature";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import moment from "moment";

const exceptSymbols = ["e", "-", "."];
const PDFSignField = (props) => {
  const [signature, setSignature] = useState(false);
  const [datePicker, setDatePicker] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const {
    formDetails,
    onChangeOptionHandler,
    onChangeHandler,
    formData,
    imgType,
    getImage,
    getText,
    getSignText,
    getFont,
    getSignType,
    getColor,
    signatureOptions,
    digest,
    handleResizeHandler,
    currentPageNumber,
    onFieldClick,
    signatureByField,
  } = props;


  useEffect(() => {
    function handleClickOutside(event) {
      const insideSignature = event.target.closest(".signature-wrapper");
      if (!insideSignature) {
        setSelectedItem(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDatePicker = (value, index, date_format) => {
    const formats = [
      "DD/MM/YYYY",
      "MM/DD/YYYY",
      "YYYY/MM/DD",
      "DD/MMM/YYYY",
      "MMM/DD/YYYY",
    ];
    let formatDate = moment(value, "DD/MM/YYYY").format(
      formats[date_format - 1]
    );
    onChangeHandler(formatDate, index, "value", currentPageNumber);
    setDatePicker(false);
  };

  let id = undefined;
  const startResize = (event, eleId) => {
    id = eleId;
    event.stopPropagation();
    event.preventDefault();
    window.addEventListener("mousemove", handleResize);
    window.addEventListener("mouseup", stopResize);
  };

  const handleResize = (event) => {
    let elementsList = document?.querySelectorAll("#sign-container");
    const elementsArray = [...elementsList];
    let element;
    elementsArray?.forEach((ele) => {
      if (
        ele?.id === "sign-container" &&
        selectedItem?.field_key === "Signature" &&
        ele?.dataset?.name === selectedItem?.field_value
      ) {
        element = ele;
      }
    });
    if (element && selectedItem && id) {
      let boundingClient = element.getBoundingClientRect();
      const data = getRECTData(event, boundingClient, selectedItem);

      if (data) {
        const { left, top, width, height } = data;
        if (left >= 0 && top >= 0 && width > 10) {
          handleResizeBox(left, top, width, height, selectedItem);
        }
      }
    }
  };

  const handleResizeBox = (left, top, width, height, item) => {
    let current = document.getElementById("resize-box");
    fLeft = left;
    current.style.left = left + "px";
    // fTop = top;
    // current.style.top = top + 'px';

    fWidth = width;
    current.style.width = width + "px";
    fHeight = height;
    if (item?.type === 12 || item?.type === 9)
      current.style.height = height + "px";
  };

  let fLeft, fTop, fWidth, fHeight;
  const stopResize = (event) => {
    window.removeEventListener("mousemove", handleResize);
    window.removeEventListener("mouseup", stopResize);

    let elementsList = document?.querySelectorAll("#sign-container");
    const elementsArray = [...elementsList];
    let element = "";
    elementsArray?.forEach((ele) => {
      if (
        ele?.id === "sign-container" &&
        selectedItem?.field_key === "Signature" &&
        ele?.dataset?.name === selectedItem?.field_value
      ) {
        element = ele;
      }
    });

    if (element && selectedItem && id) {
      let boundingClient = element.getBoundingClientRect();

      const data = getRECTData(event, boundingClient, selectedItem);

      if (data) {
        const { left, top, width, height } = data;

        if (left >= 0 && top >= 0 && width > 10) {
          setResizeData(
            left,
            top,
            width,
            height,
            element,
            selectedItem?.field_value
          );
        } else {
          setResizeData(
            fLeft,
            fTop,
            fWidth,
            fHeight,
            element,
            selectedItem?.field_value
          );
        }
      }
      id = undefined;
    }
  };

  const getRECTData = (event, boundingClient, item) => {
    if (!id) {
      return undefined;
    }

    let data = {};

    const pageX = event.clientX;
    const pageY = event.clientY;

    const x = boundingClient.left;
    const y = boundingClient.top;

    let diffX, diffY;
    switch (id) {
      case "top-left":
        diffX = x - pageX;
        // diffY = y - pageY;

        data.left = item.left - diffX;
        data.top = item.top;

        data.width = item.width + diffX;
        data.height = Number(item.height);

        return data;

      case "bottom-left":
        diffX = x - pageX;
        diffY = pageY - (y + Number(item.height));

        data.left = item.left - diffX;
        data.top = item.top;

        data.width = item.width + diffX;
        data.height = Number(item.height) + diffY;

        return data;

      case "top-right":
        diffX = pageX - (x + item.width);
        // diffY = y - pageY;

        data.left = item.left;
        data.top = item.top;

        data.width = item.width + diffX;
        data.height = Number(item.height);

        return data;

      case "bottom-right":
        diffX = pageX - (x + item.width);
        diffY = pageY - (y + Number(item.height));

        data.left = item.left;
        data.top = item.top;

        data.width = item.width + diffX;
        data.height = Number(item.height) + diffY;

        return data;
      default:
        break;
    }
  };

  const setResizeData = (left, top, width, height, element, field_value) => {
    element.style.left = left + "px";
    // element.style.top = top + 'px';

    element.style.width = width + "px";
    if (selectedItem?.type === 12 || selectedItem?.type === 9)
      element.style.height = height + "px";

    const selectedIndex = formDetails?.findIndex(
      (d) => d?.field_value === selectedId
    );
    handleResizeHandler(
      left,
      top,
      Math.round(width),
      Math.round(height),
      selectedIndex,
      field_value
    );
    fLeft = fTop = fWidth = fHeight = undefined;
  };

  return (
    <>
      {formDetails &&
        formDetails?.map((item, index) => {
          switch (item.field_key) {
            case "Name":
              return (
                <div key={`name${index}`}>
                  <Tooltip
                    title={
                      item?.is_required
                        ? `* Required - ${item?.field_key}`
                        : `Optional - ${item?.field_key}`
                    }
                    placement="top-start"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          color: "var(--header-color)",
                          backgroundColor: "#FFFAA1",
                          border: "1px solid #999",
                        },
                      },
                    }}
                    PopperProps={{
                      modifiers: [
                        { name: "offset", options: { offset: [0, -8] } },
                      ],
                    }}
                  >
                    <input
                      className="pdf-sign-field"
                      value={item.value}
                      type="text"
                      placeholder={item?.placeholder}
                      style={{
                        position: "absolute",
                        top: item.top,
                        left: item.left,
                        width: item.width + "px",
                        height: item.height + "px",
                        border:
                          item?.is_required && !item?.value
                            ? "1px solid var(--field-border-danger)"
                            : "1px solid var(--field-border-color)",
                        fontSize: item?.fontSize + "px",
                        backgroundColor: "#fff",
                        fontWeight: item?.fontWeight,
                        fontStyle: item?.fontStyle,
                        fontFamily: item?.fontFamily,
                        color: item?.color?.value,
                      }}
                      onFocus={() =>
                        onFieldClick && onFieldClick(currentPageNumber)
                      }
                      onChange={(event) =>
                        onChangeHandler(
                          event.target.value,
                          index,
                          "value",
                          currentPageNumber
                        )
                      }
                    />
                  </Tooltip>
                </div>
              );

            case "Text":
              return (
                <div key={`text${index}`}>
                  <Tooltip
                    title={
                      item?.is_required
                        ? `* Required - ${item?.field_key}`
                        : `Optional - ${item?.field_key}`
                    }
                    placement="top-start"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          color: "var(--header-color)",
                          backgroundColor: "#FFFAA1",
                          border: "1px solid #999",
                        },
                      },
                    }}
                    PopperProps={{
                      modifiers: [
                        { name: "offset", options: { offset: [0, -10] } },
                      ],
                    }}
                  >
                    <textarea
                      rows={4}
                      className="pdf-sign-field"
                      value={item?.value}
                      type="text"
                      placeholder={item?.field_label}
                      style={{
                        position: "absolute",
                        top: item.top,
                        left: item.left,
                        width: item.width + "px",
                        height: item.height + "px",
                        background: item?.is_required
                          ? "#FAEEE6"
                          : item.background,
                        border:
                          item?.is_required && !item?.value
                            ? "1px solid var(--field-border-danger)"
                            : "1px solid var(--field-border-color)",
                        fontSize: item?.fontSize + "px",
                        backgroundColor: "#fff",
                        fontWeight: item?.fontWeight,
                        fontStyle: item?.fontStyle,
                        fontFamily: item?.fontFamily,
                        color: item?.color?.value,
                        cursor: item?.is_read_only ? "not-allowed" : "pointer",
                        resize: item?.is_read_only && "none",
                      }}
                      onFocus={() =>
                        onFieldClick && onFieldClick(currentPageNumber)
                      }
                      onChange={(event) =>
                        onChangeHandler(
                          event.target.value,
                          index,
                          "value",
                          currentPageNumber
                        )
                      }
                      disabled={item?.is_read_only}
                    />
                  </Tooltip>
                </div>
              );

            case "Radio":
              return (
                <Tooltip
                  key={`redio${index}`}
                  title={
                    item?.is_required
                      ? `* Required - ${item?.field_key}`
                      : `Optional - ${item?.field_key}`
                  }
                  placement="top-start"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        color: "var(--header-color)",
                        backgroundColor: "#FFFAA1",
                        border: "1px solid #999",
                      },
                    },
                  }}
                  PopperProps={{
                    modifiers: [
                      { name: "offset", options: { offset: [0, -1] } },
                    ],
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      width: item.width,
                      top: item.top,
                      left: item.left,
                    }}
                  >
                    {item?.options?.map((list, idx) => {
                      return (
                        <div
                          style={{
                            marginBottom: "3px",
                            top: list?.to,
                            border:
                              item?.is_required && !item?.selected_value
                                ? "1px solid var(--field-border-danger)"
                                : "1px solid var(--field-border-color)",
                          }}
                          className="sign_radio"
                          key={idx + 1}
                        >
                          <input
                            className="radio-select-field"
                            style={{
                              opacity: list.is_selected ? "1" : "0",
                              fontSize: item?.fontSize + "px",
                            }}
                            onClick={() => {
                              onFieldClick && onFieldClick(currentPageNumber);
                              onChangeOptionHandler(
                                list?.is_selected,
                                index,
                                list?.value,
                                "RadioButton",
                                currentPageNumber
                              );
                            }}
                            value={list?.is_selected}
                            onChange={(e) => {}}
                          />
                        </div>
                      );
                    })}
                  </div>
                </Tooltip>
              );

            case "Checkbox":
              return (
                <Tooltip
                  key={`checkbox${index}`}
                  title={
                    item?.is_required
                      ? `* Required - ${item?.field_key}`
                      : `Optional - ${item?.field_key}`
                  }
                  placement="top-start"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        color: "var(--header-color)",
                        backgroundColor: "#FFFAA1",
                        border: "1px solid #999",
                      },
                    },
                  }}
                  PopperProps={{
                    modifiers: [
                      { name: "offset", options: { offset: [0, -1] } },
                    ],
                  }}
                >
                  <div
                    style={{
                      width: "20px",
                      top: item.top,
                      left: item.left,
                      position: "absolute",
                    }}
                  >
                    {item?.options?.map((list, idx) => {
                      return (
                        <div key={idx} style={{ marginBottom: "5px" }}>
                          <Checkbox
                            icon={
                              list.is_selected && (
                                <div className="custom-icon">
                                  <div className="icon-before" />{" "}
                                  <div className="icon-after" />
                                </div>
                              )
                            }
                            checked={list?.is_selected}
                            value={list?.value}
                            onClick={() =>
                              onFieldClick && onFieldClick(currentPageNumber)
                            }
                            onChange={(value) =>
                              onChangeOptionHandler(
                                value,
                                index,
                                list?.value,
                                "Checkbox",
                                currentPageNumber
                              )
                            }
                            style={{
                              border:
                                item?.is_required && !item?.selected_value
                                  ? "1px solid var(--field-border-danger)"
                                  : "1px solid var(--field-border-color)",
                            }}
                            className="checkbox-custom"
                          />
                        </div>
                      );
                    })}
                  </div>
                </Tooltip>
              );

            case "Dropdown":
              return (
                <Box key={`dropdown${index}`}>
                  <Tooltip
                    title={
                      item?.is_required
                        ? `* Required - ${item?.field_key}`
                        : `Optional - ${item?.field_key}`
                    }
                    placement="top-start"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          color: "var(--header-color)",
                          backgroundColor: "#FFFAA1",
                          border: "1px solid #999",
                        },
                      },
                    }}
                    PopperProps={{
                      modifiers: [
                        { name: "offset", options: { offset: [0, -10] } },
                      ],
                    }}
                  >
                    <Select
                      sx={{
                        boxShadow: "none",
                        fontSize: "12px",
                        color: "var(--table-font-color)",
                        ".MuiOutlinedInput-notchedOutline": { border: "none" },
                        border:
                          item?.is_required && !item?.selected_value
                            ? "1px solid var(--field-border-danger)"
                            : "1px solid var(--field-border-color)",
                        "& .MuiSelect-select": { paddingLeft: "4px" },
                      }}
                      MenuProps={{
                        disableScrollLock: true,
                        classes: { paper: "dropdown-container-pdf2" },
                      }}
                      style={{
                        position: "absolute",
                        top: item.top,
                        left: item.left,
                        width:
                          item.width === 110 ? "125px" : item?.width + "px",
                        height: item.height + "px",
                        fontSize: item?.fontSize + "px",
                        fontWeight: item?.fontWeight,
                        fontStyle: item?.fontStyle,
                        fontFamily: item?.fontFamily,
                        color: item?.color?.value,
                      }}
                      defaultValue="choose"
                      onFocus={() =>
                        onFieldClick && onFieldClick(currentPageNumber)
                      }
                      onChange={(e) => [
                        onChangeOptionHandler(
                          e.target.value,
                          index,
                          null,
                          "Dropdown",
                          currentPageNumber
                        ),
                      ]}
                    >
                      <MenuItem className="select-sign-body" value="choose">
                        <span>--Select--</span>
                      </MenuItem>
                      {item?.options?.map((list, idx) => {
                        return (
                          <MenuItem
                            key={idx}
                            value={list.value}
                            className="select-sign-body"
                          >
                            <span>{list.value}</span>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </Tooltip>
                </Box>
              );

            case "Url":
              return (
                <div key={`url${index}`}>
                  <Tooltip
                    title={
                      item?.is_required
                        ? `* Required - ${item?.field_key}`
                        : `Optional - ${item?.field_key}`
                    }
                    placement="top-start"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          color: "var(--header-color)",
                          backgroundColor: "#FFFAA1",
                          border: "1px solid #999",
                        },
                      },
                    }}
                    PopperProps={{
                      modifiers: [
                        { name: "offset", options: { offset: [0, -10] } },
                      ],
                    }}
                  >
                    <input
                      className={
                        item?.is_required
                          ? "pdf-sign-field-required"
                          : "pdf-sign-field"
                      }
                      value={item.value}
                      type="text"
                      style={{
                        position: "absolute",
                        top: item.top,
                        left: item.left,
                        width: item.width + "px",
                        height: item.height + "px",
                        background: item?.is_required
                          ? "#FAEEE6"
                          : item.background,
                        border: item?.is_required ? "1px solid #ED4C78" : "",
                        fontSize: item?.fontSize + "px",
                        fontWeight: item?.fontWeight,
                        fontStyle: item?.fontStyle,
                        fontFamily: item?.fontFamily,
                        color: item?.color?.value,
                      }}
                      onFocus={() =>
                        onFieldClick && onFieldClick(currentPageNumber)
                      }
                      onChange={(event) =>
                        onChangeHandler(
                          event.target.value,
                          index,
                          "value",
                          currentPageNumber
                        )
                      }
                      placeholder={item?.placeholder}
                    />
                  </Tooltip>
                </div>
              );

            case "Date":
              return (
                <Box key={`date${index}`}>
                  <Tooltip
                    title={
                      item?.is_required
                        ? `* Required - ${item?.field_key}`
                        : `Optional - ${item?.field_key}`
                    }
                    placement="top-start"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          color: "var(--header-color)",
                          backgroundColor: "#FFFAA1",
                          border: "1px solid #999",
                        },
                      },
                    }}
                    PopperProps={{
                      modifiers: [
                        { name: "offset", options: { offset: [0, -10] } },
                      ],
                    }}
                  >
                    <input
                      className="pdf-sign-field"
                      value={item.value}
                      type="text"
                      onClick={() => {
                        onFieldClick && onFieldClick(currentPageNumber);
                        setDatePicker(index);
                      }}
                      style={{
                        position: "absolute",
                        top: item.top,
                        left: item.left,
                        width: item.width + "px",
                        height: item.height + "px",
                        backgroundColor: "#fff",
                        border:
                          item?.is_required && !item?.value
                            ? "1px solid var(--field-border-danger)"
                            : "1px solid var(--field-border-color)",
                        fontSize: item?.fontSize + "px",
                        zIndex: 1,
                        fontWeight: item?.fontWeight,
                        fontStyle: item?.fontStyle,
                        fontFamily: item?.fontFamily,
                        color: item?.color?.value,
                      }}
                      onChange={() => {}}
                      placeholder={item?.placeholder}
                    />
                  </Tooltip>
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    key={index + 1}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: item.top,
                        left: item.left,
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          "& div": {
                            position: "absolute",
                            padding: 0,
                          },
                        }}
                      >
                        <DatePicker
                          viewRenderers={null}
                          sx={{
                            "& .css-1anqmj6-MuiPopper-root-MuiPickersPopper-root":
                              {
                                scale: "0.7",
                              },
                            "& .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root":
                              {
                                opacity: 0,
                                pointerEvents: "none",
                              },
                            "& .css-nk89i7-MuiPickersCalendarHeader-root": {
                              background: "red",
                            },
                            "& .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input":
                              {
                                padding: 0,
                                border: "none",
                              },
                            "& .css-1yq5fb3-MuiButtonBase-root-MuiIconButton-root":
                              {
                                display: "none",
                                border: "none",
                              },
                            "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                              borderWidth: "0px",
                            },
                            "& .css-3gxj82.Mui-error .MuiOutlinedInput-notchedOutline":
                              {
                                border: "none",
                              },
                            "& .css-vubbuv": {
                              display: "none",
                            },
                            "& .css-igs3ac": {
                              borderWidth: "0px",
                            },
                            fontFamily: "var(--primary-font-family)",
                            color: "var(--table-font-color)",
                            zIndex: 1,
                            padding: 0,
                          }}
                          closeOnSelect={true}
                          open={datePicker === index}
                          value={dayjs(item.value, item?.date_format)}
                          onClose={() => setDatePicker(false)}
                          minDate={dayjs(new Date())}
                          format="DD-MM-YYYY"
                          onChange={(date) => {
                            handleDatePicker(date.$d, index, item?.date_format);
                          }}
                        />
                      </Box>
                    </Box>
                  </LocalizationProvider>
                </Box>
              );

            case "Email":
              return (
                <div key={`email${index}`}>
                  <Tooltip
                    title={
                      item?.is_required
                        ? `* Required - ${item?.field_key}`
                        : `Optional - ${item?.field_key}`
                    }
                    placement="top-start"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          color: "var(--header-color)",
                          backgroundColor: "#FFFAA1",
                          border: "1px solid #999",
                        },
                      },
                    }}
                    PopperProps={{
                      modifiers: [
                        { name: "offset", options: { offset: [0, -10] } },
                      ],
                    }}
                  >
                    <input
                      className="pdf-sign-field"
                      value={item.value}
                      type="text"
                      style={{
                        position: "absolute",
                        top: item.top,
                        left: item.left,
                        width: item.width + "px",
                        height: item.height + "px",
                        backgroundColor: "#fff",
                        border:
                          item?.is_required && !item?.value
                            ? "1px solid var(--field-border-danger)"
                            : "1px solid var(--field-border-color)",
                        fontSize: item?.fontSize + "px",
                        fontWeight: item?.fontWeight,
                        fontStyle: item?.fontStyle,
                        fontFamily: item?.fontFamily,
                        color: item?.color?.value,
                      }}
                      onFocus={() =>
                        onFieldClick && onFieldClick(currentPageNumber)
                      }
                      onChange={(event) =>
                        onChangeHandler(
                          event.target.value,
                          index,
                          "value",
                          currentPageNumber
                        )
                      }
                      placeholder={item?.placeholder}
                    />
                  </Tooltip>
                </div>
              );

            case "Signature":
              return (
                <>
                  <div
                    className="signature-wrapper"
                    key={`signature${index}`}
                    aria-hidden="true"
                    onClick={(e) => {
                      e.stopPropagation();
                      onFieldClick && onFieldClick(currentPageNumber);
                      setSelectedId(item?.field_value);
                      
                      setSelectedItem(item);
                    }}
                  >
                    <Tooltip
                      title={
                        item?.is_required
                          ? `* Required - ${item?.field_key}`
                          : `Optional - ${item?.field_key}`
                      }
                      placement="top-start"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            color: "var(--header-color)",
                            backgroundColor: "#FFFAA1",
                            border: "1px solid #999",
                          },
                        },
                      }}
                      PopperProps={{
                        modifiers: [
                          { name: "offset", options: { offset: [0, -10] } },
                        ],
                      }}
                    >
                      <>
                        {selectedId === item?.field_value && (
                          <div
                            title={item?.field_value}
                            id="resize-box"
                            className="pdf-resize-field"
                            style={{
                              position: "absolute",
                              top: `${item.top}px`,
                              left: item.left,
                              width: item.width + "px",
                              height: item.height + "px",
                              backgroundColor: "transparent",
                              zIndex: "100",
                            }}
                          >
                            <div
                              className="circle-container"
                              style={{
                                position: "absolute",
                                top: "-7px",
                                left: "-7px",
                                cursor: "not-allowed",
                              }}
                            />
                            <div
                              onMouseDown={(ev) => {
                                ev.stopPropagation();
                                startResize(ev, "top-right");
                              }}
                              className="circle-container"
                              style={{
                                position: "absolute",
                                top: "-7px",
                                right: "-7px",
                                cursor: "nesw-resize",
                              }}
                            />
                            <div
                              className="circle-container"
                              style={{
                                position: "absolute",
                                left: "-7px",
                                bottom: "-7px",
                                cursor: "not-allowed",
                              }}
                            />
                            <div
                              onMouseDown={(ev) => {
                                ev.stopPropagation();
                                startResize(ev, "bottom-right");
                              }}
                              className="circle-container"
                              style={{
                                position: "absolute",
                                right: "-7px",
                                bottom: "-7px",
                                cursor: "nwse-resize",
                              }}
                            />
                          </div>
                        )}
                        <Box
                          className="pdf-sign-field"
                          style={{
                            position: "absolute",
                            top: item.top,
                            left: item.left,
                            width: item?.width,
                            height: item.height + "px",
                            backgroundColor: "#fff",
                            border:
                              !(
                                Object.keys(getImage)?.length !== 0 ||
                                getSignText
                              ) && item?.is_required
                                ? "1px solid var(--field-border-danger)"
                                : "1px solid var(--field-border-color)",
                            fontSize: item?.fontSize + "px",
                            cursor: "pointer",
                            alignItems: "center",
                            display: "flex",
                            whiteSpace: "nowrap",
                            zIndex: "100",
                          }}
                          id="sign-container"
                          data-name={item?.field_value}
                          onClick={() => {
                            onFieldClick && onFieldClick(currentPageNumber);
                            setSignature(true);
                          }}
                        >
                          {Object.keys(getImage)?.length !== 0 ||
                          signatureByField?.[item?.field_value] ? (
                            <img
                              width="100%"
                              height="100%"
                              style={{
                                objectFit: "fill",
                                position: "relative",
                                display: "flex",
                                justifyContent: "center",
                              }}
                              draggable={false}
                              src={
                                Object.keys(getImage)?.length !== 0
                                  ? getImage
                                  : signatureByField?.[item?.field_value]
                              }
                              alt="signature"
                            />
                          ) : (
                            <div
                              style={{
                                color: "var(--primary)",
                                paddingLeft: "2px",
                              }}
                            >
                              {item.placeholder}
                            </div>
                          )}
                        </Box>
                      </>
                    </Tooltip>
                  </div>
                  {signature && (
                    <PDFSignature
                      digest={digest}
                      showModal={signature}
                      signatureOptions={signatureOptions}
                      signatureModal={(val) => setSignature(val)}
                      getType={getSignType}
                      imgType={(val) => imgType(val)}
                      type={(type) => getText(type, "type")}
                      getImage={(value, applyAll) => {
                        formData(
                          value,
                          applyAll,
                          selectedId,
                          currentPageNumber
                        );
                        
                      }}
                      getText={(e) => getText(e, "text")}
                      getColor={(color) => getText(color, "color")}
                      getFont={(font) => getText(font, "font")}
                    />
                  )}
                </>
              );

            case "Company":
              return (
                <div key={`company${index + 1}`}>
                  <Tooltip
                    title={
                      item?.is_required
                        ? `* Required - ${item?.field_key}`
                        : `Optional - ${item?.field_key}`
                    }
                    placement="top-start"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          color: "var(--header-color)",
                          backgroundColor: "#FFFAA1",
                          border: "1px solid #999",
                        },
                      },
                    }}
                    PopperProps={{
                      modifiers: [
                        { name: "offset", options: { offset: [0, -10] } },
                      ],
                    }}
                  >
                    <input
                      className="pdf-sign-field"
                      value={item.value}
                      type="text"
                      placeholder={item?.placeholder}
                      style={{
                        position: "absolute",
                        top: item.top,
                        left: item.left,
                        width: item.width + "px",
                        height: item.height + "px",
                        backgroundColor: "#fff",
                        border:
                          item?.is_required && !item?.value
                            ? "1px solid var(--field-border-danger)"
                            : "1px solid var(--field-border-color)",
                        fontSize: item?.fontSize + "px",
                        fontWeight: item?.fontWeight,
                        fontStyle: item?.fontStyle,
                        fontFamily: item?.fontFamily,
                        color: item?.color?.value,
                      }}
                      onFocus={() =>
                        onFieldClick && onFieldClick(currentPageNumber)
                      }
                      onChange={(event) =>
                        onChangeHandler(
                          event.target.value,
                          index,
                          "value",
                          currentPageNumber
                        )
                      }
                    />
                  </Tooltip>
                </div>
              );

            case "Number":
              return (
                <div key={`number${index}`}>
                  <Tooltip
                    title={
                      item?.is_required
                        ? `* Required - ${item?.field_key}`
                        : `Optional - ${item?.field_key}`
                    }
                    placement="top-start"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          color: "var(--header-color)",
                          backgroundColor: "#FFFAA1",
                          border: "1px solid #999",
                        },
                      },
                    }}
                    PopperProps={{
                      modifiers: [
                        { name: "offset", options: { offset: [0, -10] } },
                      ],
                    }}
                  >
                    <input
                      className="pdf-sign-field"
                      value={item.value}
                      type="text"
                      onKeyDown={(evt) =>
                        exceptSymbols.includes(evt.key) && evt.preventDefault()
                      }
                      placeholder={item?.placeholder}
                      style={{
                        position: "absolute",
                        top: item.top,
                        left: item.left,
                        width: item.width + "px",
                        height: item.height + "px",
                        backgroundColor: "#fff",
                        border:
                          item?.is_required && !item?.value
                            ? "1px solid var(--field-border-danger)"
                            : "1px solid var(--field-border-color)",
                        fontSize: item?.fontSize + "px",
                        fontWeight: item?.fontWeight,
                        fontStyle: item?.fontStyle,
                        fontFamily: item?.fontFamily,
                        color: item?.color?.value,
                      }}
                      onFocus={() =>
                        onFieldClick && onFieldClick(currentPageNumber)
                      }
                      onChange={(event) =>
                        onChangeHandler(
                          event.target.value,
                          index,
                          "value",
                          currentPageNumber
                        )
                      }
                    />
                  </Tooltip>
                </div>
              );

            case "Title":
              return (
                <div key={`Title${index}`}>
                  <Tooltip
                    title={
                      item?.is_required
                        ? `* Required - ${item?.field_key}`
                        : `Optional - ${item?.field_key}`
                    }
                    placement="top-start"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          color: "var(--header-color)",
                          backgroundColor: "#FFFAA1",
                          border: "1px solid #999",
                        },
                      },
                    }}
                    PopperProps={{
                      modifiers: [
                        { name: "offset", options: { offset: [0, -10] } },
                      ],
                    }}
                  >
                    <input
                      className="pdf-sign-field"
                      value={item.value}
                      type="text"
                      placeholder={item?.placeholder}
                      style={{
                        position: "absolute",
                        top: item.top,
                        left: item.left,
                        width: item.width + "px",
                        height: item.height + "px",
                        backgroundColor: "#fff",
                        border:
                          item?.is_required && !item?.value
                            ? "1px solid var(--field-border-danger)"
                            : "1px solid var(--field-border-color)",
                        fontSize: item?.fontSize + "px",
                        fontWeight: item?.fontWeight,
                        fontStyle: item?.fontStyle,
                        fontFamily: item?.fontFamily,
                        color: item?.color?.value,
                      }}
                      onFocus={() =>
                        onFieldClick && onFieldClick(currentPageNumber)
                      }
                      onChange={(event) =>
                        onChangeHandler(
                          event.target.value,
                          index,
                          "value",
                          currentPageNumber
                        )
                      }
                    />
                  </Tooltip>
                </div>
              );

            case "Initial":
              return (
                <div key={`Initial${index}`}>
                  <Tooltip
                    title={
                      item?.is_required
                        ? `* Required - ${item?.field_key}`
                        : `Optional - ${item?.field_key}`
                    }
                    placement="top-start"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          color: "var(--header-color)",
                          backgroundColor: "#FFFAA1",
                          border: "1px solid #999",
                        },
                      },
                    }}
                    PopperProps={{
                      modifiers: [
                        { name: "offset", options: { offset: [0, -10] } },
                      ],
                    }}
                  >
                    <input
                      className="pdf-sign-field"
                      value={item.value}
                      type="text"
                      placeholder={item?.placeholder}
                      style={{
                        position: "absolute",
                        top: item.top,
                        left: item.left,
                        width: item.width + "px",
                        height: item.height + "px",
                        backgroundColor: "#fff",
                        border:
                          item?.is_required && !item?.value
                            ? "1px solid var(--field-border-danger)"
                            : "1px solid var(--field-border-color)",
                        fontSize: item?.fontSize + "px",
                        fontWeight: item?.fontWeight,
                        fontStyle: item?.fontStyle,
                        fontFamily: item?.fontFamily,
                        color: item?.color?.value,
                      }}
                      onFocus={() =>
                        onFieldClick && onFieldClick(currentPageNumber)
                      }
                      onChange={(event) =>
                        onChangeHandler(
                          event.target.value,
                          index,
                          "value",
                          currentPageNumber
                        )
                      }
                    />
                  </Tooltip>
                </div>
              );

            default:
              return (
                <div key={`name${index}`}>
                  <input
                    className={
                      item.value ? "pdf_board_field" : "pdf_board_field_empty"
                    }
                    value={item.value}
                    type="text"
                    placeholder={item?.placeholder}
                    style={{
                      position: "absolute",
                      top: item.top,
                      left: item.left,
                      width: item.width + "px",
                      height: item.height + "px",
                      border: "1px solid var(--field-border-color) !important",
                      fontSize: item?.fontSize + "px",
                      backgroundColor: "#fff",
                      fontWeight: item?.fontWeight,
                      fontStyle: item?.fontStyle,
                      fontFamily: item?.fontFamily,
                      color: item?.color?.value,
                    }}
                    onChange={(event) => {}}
                  />
                </div>
              );
          }
        })}
    </>
  );
};

export default PDFSignField;
